
import { Body } from "../Components/HomeBody/homeBody";


const HomePage = () => {
 
  return (
    <>
     <Body/>
    </>
  );
};

export { HomePage };
